import EditIcon from '@mui/icons-material/Edit';
import EditOffIcon from '@mui/icons-material/EditOff';

const EditIconWrapper = props => {
  const { data, disabled, onEdit } = props;

  let icon;
  if (disabled) {
    icon = <EditOffIcon color="disabled" />;
  } else {
    icon = <EditIcon sx={{color: '#000', cursor: 'pointer'}} onClick={() => onEdit(data)} />;
  }

  return <div title="Edit">{icon}</div>;
}

export default EditIconWrapper;
